import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import enJSON from './translations/en';
import esJSON from './translations/es';

const resources = {
  en: { translation: enJSON },
  es: { translation: esJSON },
};

const lng = localStorage.getItem('language');
i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: lng || 'es',
    fallbackLng: 'es',
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
